import React from "react";
import { motion } from "framer-motion";

export const SectionHeading = ({ eyebrow, title, titleMuted, subtitle, center = true }) => (
  <div className={`${center ? "text-center mx-auto" : ""} max-w-2xl mb-10 sm:mb-14`}>
    {eyebrow && <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-cyanx/80">{eyebrow}</span>}
    <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
      <span className="text-foreground">{title}</span>{" "}
      {titleMuted && <span className="text-muted-foreground">{titleMuted}</span>}
    </h2>
    {subtitle && <p className="mt-4 text-base text-muted-foreground">{subtitle}</p>}
  </div>
);

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}>
    {children}
  </motion.div>
);
